export default {
  init() {

  },
  finalize() {

    // edit these vars
    var nice_url   = true;
    var pagination = false;
    var animation_speed = '0';
    var post_order = 'DESC';
    var random_posts = true;
    var featured_image = true;
    var acf = true;

    // default vars
    var page      = 0;
    var filter    = 0;
    var numberposts = 8;
    var total_item_count = 0;
    var exlude_ids = [];
    var seed = Math.floor(Math.random() * 1000) + 1;

    // loop the filter buttons and check if selected filter is set
    $('.lazy-load-filter').each(function() {
      // if finds selected index set the filter id
      if($(this).data('selected')) {
        filter = $(this).data('index');
      }
    })

    // load initail items
    getLazyItems();

    // assign buttons to clicks
    $('.lazy-load-more').click(() => getLazyItems());
    $('.lazy-load-filter').click((e) => setLazyFilter(e));
    $('.lazy-load-filter-mobile').change((e) => setLazyFilter(e, true));

    function setLazyFilter(e, mobile = false) {
      var target = $(e.target);

      if(mobile) {
        target = $(e.target).find(':selected');
      }

      // clear current items from div
      exlude_ids = [];

      $('.lazy-load-items').fadeOut(animation_speed, function() {

        // Animation complete.
        $('.lazy-load-items').empty();
        // reset page to 0
        page = 0;

        // set the filter id from the data index
        filter = target.data('index');

        // get the items with the new filter id
        getLazyItems()

        $('.lazy-load-filter').each(function() {
          $(this).removeClass('active');
        })

        target.addClass('active');

        $('.lazy-load-items').fadeIn( animation_speed);
        //set pretty slug url
        if(nice_url) {
          window.history.pushState('', '', target.data('slug'));
        }
      });
    }

    function getLazyItems() {
      console.log('lazy');
      // hide load more button to counter flickering
      $('.lazy-load-pagination').hide();

      // eslint-disable-next-line no-undef
      var ajax_url = ajax_object.ajax_url;

      // set initial post count
      total_item_count = 5;

      var tax_query = '';

      if(filter != 0) {
        tax_query = [{
          'taxonomy': 'vacancies_category',
          'field': 'slug',
          'terms': filter,
        }];
      }

      // do ajax(super joden) call to the server
      $.ajax({
        type: 'post',
        url: ajax_url,
        data : {
          action: 'lazyload', // action called in ajax.php
          featured_image: featured_image,
          acf: acf,
          args: { // args parameters passed to wp_query method
            'posts_per_page': numberposts,
            'post_type': 'vacancies',
            'post_status':'publish',
            'paged': page + 1,
            'tax_query': tax_query,
            'order': post_order,
            'orderby': random_posts ? 'RAND(' + seed + ')' : 'ID',
          },
        },
      }).done(function(items) {

        //
        $('.lazy-load-pagination').show();

        // set items string to array
        var responseItems = JSON.parse(items);

        // set global total var
        total_item_count = responseItems.total_item_count;

        // check if items available
        if(responseItems.items.length > 0 ) {

          var item_html = '';

          // loop the items
          responseItems.items.map((element) => {

            if(random_posts) {
              if(exlude_ids.includes(element.ID) === false) {
                exlude_ids.push(element.ID);
              }
            }
            console.log(exlude_ids);
            // style the items and append them to the frontend div
            item_html += `<div class="vacancies__item flex w-full md:w-1/2 lg:w-4/12 mb-4 px-2 group">
                            <div class="p-8 xl:p-12 w-full relative vacancies__wrapper bg-white rounded-xl transition duration-500 ease-in-out">
                              <a href="${element.permalink}" class="absolute inset-0 z-30"></a>
                              <div class="relative z-20 vacancies__content h-full flex flex-col">
                                <h3 class="font-sans text-1xl sm:text-2xl font-bold truncate relative w-full">
                                  <div class="relative z-10">
                                    ${element.post_title}
                                  </div>
                                </h3>
                                <div class="flex items-center">
                                  <div class="inline-block bg-secondary text-primary font-bold py-2 px-4 rounded-full leading-tight font-primary text-xs sm:text-sm">
                                    ${element.term_vacancies}
                                  </div>
                                  <div class="inline-block bg-transparent ml-2 border border-gray-100 text-primary font-bold py-2 px-4 rounded-full leading-tight font-primary text-xs sm:text-sm">
                                    ${element.tags_vacancies}
                                  </div>
                                </div>
                                <p class="text-black text-base font-sans my-4 lg:my-6 truncate-4-lines">${element.excerpt}</p>
                                <div class="text-secondary font-semibold flex items-center transition-all duration-500 ease-in-out">
                                  <div class="group h-4 w-4 inline-flex items-center justify-center rounded-full mr-2 border border-secondary transition duration-500 ease-in-out group-hover:bg-secondary">
                                    <svg class="transition duration-500 ease-in-out fill-current text-secondary group-hover:text-white" xmlns="http://www.w3.org/2000/svg" width="4" height="6" viewBox="0 0 4 6">
                                      <path d="M5.61252706,11.6125271 C5.87879362,11.3462605 6.2954573,11.3220544 6.5890688,11.5399089 L6.67318723,11.6125271 L8,12.939 L9.32681277,11.6125271 C9.59307933,11.3462605 10.009743,11.3220544 10.3033545,11.5399089 L10.3874729,11.6125271 C10.6537395,11.8787936 10.6779456,12.2954573 10.4600911,12.5890688 L10.3874729,12.6731872 L8.53033009,14.5303301 C8.42382346,14.6368367 8.2932533,14.7046137 8.15612035,14.7336609 L8.05231357,14.7481845 L7.94768643,14.7481845 C7.80836589,14.7385021 7.67123294,14.69009 7.55378835,14.6029482 L7.46966991,14.5303301 L5.61252706,12.6731872 C5.31963384,12.380294 5.31963384,11.9054203 5.61252706,11.6125271 Z" transform="rotate(-90 0 11.07)"/>
                                    </svg>
                                  </div>
                                  Meer info
                                </div>
                              </div>
                            </div>
                          </div>`;
          });

          $('.lazy-load-items').fadeIn(animation_speed, function() {});

          if(pagination) {
            $('.lazy-load-items').html(item_html);
          } else {
            $('.lazy-load-items').append(item_html);
          }

        } else {
          // no items available
          if(!pagination) {
            $('.lazy-load-items').append('<div class="end-lazyload text-center text-sm opacity-50 w-full">Alle items zijn ingeladen</div>');
          }
        }

      }).then(function(){
        renderPagination()
      });
    }

    function nextPage(){page = page + 1;}
    function prevPage(){page = page - 1;}
    function setPage(pageNumber){page = pageNumber;}

    function renderPagination() {
      var total_render_pages = Math.ceil(total_item_count / numberposts);

      var pagination_render = '';

      if(pagination) {

        for (var i = 0; i < total_render_pages; i++) {
          pagination_render += '<button class="lazy-load-set-page" data-page="'+i+'">'+(i + 1) +'</button>';
        }

      } else {
        if(total_render_pages >= 1 ) {
          pagination_render +='<div class="lazy-load-more button button--primary table w-auto mx-auto mt-4">Meer laden</div>';
        }
      }

      $('.lazy-load-pagination').html(pagination_render);
    }

    $('.lazy-load-pagination').on('click', '.lazy-load-more', function() {
        nextPage();
        getLazyItems();
    });

    $('.lazy-load-pagination').on('click', '.lazy-load-prev', function() {
        prevPage()
        getLazyItems();
    });

    $('.lazy-load-pagination').on('click', '.lazy-load-next', function() {
        nextPage();
        getLazyItems();
    });
    $('.lazy-load-pagination').on('click', '.lazy-load-set-page', function() {
        setPage($(this).data('page'));
        getLazyItems();

    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/vacancies.js